<div class="bmarkSpotRiskTraderGroupContainer" *ngIf="isZero === false; else showZero">
  <span *ngIf="fillAmtText != null && !isFullyFilled && hasActiveOrders; else normalRender">
    <span
      [ngClass]="{ 'bmarkSpotRiskAmtNegative' : isNegative === true, 'bmarkSpotRiskAmtPositive': isNegative === false }"
    >
      {{fillAmtText}}
    </span>
    of {{totalAmtText}}
  </span>
</div>

<ng-template #normalRender>
  <span
    [ngClass]="{ 'bmarkSpotRiskAmtNegative' : isNegative === true, 'bmarkSpotRiskAmtPositive': isNegative === false }"
    >{{totalAmtText}} {{materialSuffix ? ' Oz' : ''}}</span
  >
</ng-template>

<ng-template #showZero>
  <span>{{displayEmpty ? '-' : '&nbsp;'}}</span>
</ng-template>
